import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ts1 from '../../images/slider/sanota-icon.webp';
import ts3 from '../../images/slider/plantec.webp';
import ts2 from '../../images/slider/crafted-leaves.webp';
import ts4 from '../../images/slider/man.webp';


class Testimonial extends Component {
    render() {
        var settings = {
            dots: false,
            arrows: true,
            speed: 3000,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: { slidesToShow: 2, slidesToScroll: 1, infinite: true }
                },
                {
                    breakpoint: 991,
                    settings: { slidesToShow: 2, slidesToScroll: 1 }
                },
                {
                    breakpoint: 767,
                    settings: { slidesToShow: 1, slidesToScroll: 1 }
                },
                {
                    breakpoint: 480,
                    settings: { slidesToShow: 1, slidesToScroll: 1 }
                }
            ]
        };

        const testimonial = [
            {
                tsImg: ts1,
                Des: "Knoweb Solutions built a clean, professional website for us and handled our digital marketing end-to-end. We've seen significant growth since partnering with them.",
                Title: 'Sanota PVT LTD',
                Sub: "Director ",
            },
            {
                tsImg: ts2,
                Des: "From our website to our product packaging and social media, Knoweb brought our brand to life beautifully. Highly satisfied with the creativity and dedication.",
                Title: 'Crafted Leaves',
                Sub: "Founder",
            },
            {
                tsImg: ts3,
                Des: "Very happy with our custom site and online presence. The Knoweb team understood our needs and delivered exactly what we wanted, on time.",
                Title: 'Plantec Ceylon',
                Sub: "Owner",
            },
            {
                tsImg: ts4,
                Des: "Our social media looks more professional and gets much better engagement now. Knoweb Solutions has been a great partner to work with.",
                Title: 'HK Holdings',
                Sub: "Manager ",
            }
        ];

        return (
            <section className={`wpo-testimonial-section section-padding ${this.props.tClass}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-12">
                            <div className="wpo-testimonial-title">
                                <h2><i className="fi flaticon-left-quote"></i> Hear from <span>Our Clients</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="wpo-testimonial-items wpo-testimonial-slider owl-carousel">
                        <Slider {...settings}>
                            {testimonial.map((tesmnl, tsm) => (
                                <div className="wpo-testimonial-item" key={tsm}>
                                    <div className="wpo-testimonial-avatar">
                                        <img src={tesmnl.tsImg} alt={tesmnl.Title} />
                                    </div>
                                    <div className="wpo-testimonial-text">
                                        <p>{tesmnl.Des}</p>
                                        <div className="wpo-testimonial-text-btm">
                                            <h3>{tesmnl.Title}</h3>
                                            <span>{tesmnl.Sub}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
        );
    }
}

export default Testimonial;
